import React from 'react'
import { observer } from 'mobx-react'
import { LayerGroup } from 'react-leaflet'
import _ from 'lodash'
import { turfPointToLatLng } from 'utils'
import DrawingHandle from './DrawingHandle'

const LineDrawingHandleList = ({ line }) => (
  <LayerGroup>
    {
      _.map(line.points, (point, i) => (
        <DrawingHandle
          position={turfPointToLatLng(point)}
          radius={6}
          key={i}
          last={
            (line.points.length > 0) &&
            (line.points.length === i + 1)
          }
        />
      ))
    }
  </LayerGroup>
)

export default observer(LineDrawingHandleList)
